// src/redux/Admin/employeeViewSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  employeeName: '',
};

const employeeViewSlice = createSlice({
  name: 'employeeView',
  initialState,
  reducers: {
    setEmployeeName(state, action) {
      state.employeeName = action.payload;
    },
    resetEmployeeName(state) {
      state.employeeName = '';
    },
  },
});

export const { setEmployeeName, resetEmployeeName } = employeeViewSlice.actions;
export default employeeViewSlice.reducer;
